export default window._cmsContent['solar/solar-header']